/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  VerifyContainer, VerifyHeader, VerifyImage, VerifyText, VerifyWrapper, ResendButton,
} from './verifyElements';
import img1 from '../../Images/Verify/verify-1.svg';
import useAuth from '../../Hooks/useAuth';
import axios from '../../Api/axios';

const index = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { auth } = useAuth();

  const { email } = state;

  const resend = () => {
    axios.post(
      '/resendVerify',
      JSON.stringify({
        email,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'success') {
        alert('Email sent! Please check your email.');
      } else {
        alert('Error when sending email. Please try again later.');
      }
    }).catch((err) => {
      console.log(err);
      alert('Error when performing');
    });
  };

  useEffect(() => {
    if (auth.email || !email) navigate('/');
  }, []);

  return (
    <VerifyContainer>
      <VerifyWrapper>
        <VerifyImage alt="email" src={img1} />
        <VerifyHeader>Verify your email</VerifyHeader>
        <VerifyText>
          {`We've sent email to ${email} to verify your
        email address and activate your account. The link in email will expire in 30 minutes.`}
        </VerifyText>
        <VerifyText>
          {`Just click on the link in that email to complete your signup.
          If you don't see it, you may need to check your spam folder.`}
        </VerifyText>
        <VerifyText>
          <ResendButton type="button" onClick={resend}>Click here!</ResendButton>
          to resend verification email.
        </VerifyText>
      </VerifyWrapper>
    </VerifyContainer>
  );
};

export default index;
